import React from 'react';
import {numberClass} from 'components/manager-dashboard/Common';
import classnames from 'classnames';
import TableScore from 'components/manager-dashboard/strengths-and-weaknesses/TableScore';

/**
 * calculate the total points and scorecards across all members for a specific skill
 * @param skill name of the skill
 * @param scores map of all scores
 * @returns {number}
 */
function reduceAllScores(skill, scores) {
  const pointsAndCount = scores
    .valueSeq()
    .map(item => item.skillScores)
    .filter(item => item[skill] !== undefined)
    .reduce(([points, count], item) => [points + item[skill].skillAverage, count + 1], [0, 0]);
  const [points, count] = pointsAndCount;
  return count > 0 ? points / count : 0;
}

class TableFoot extends React.PureComponent {
  render() {
    const {skillsOrder, scores, scorecardsCount, hoverIndex} = this.props;
    const totalAverages = scores.valueSeq().reduce((acc, item) => acc + item.average, 0);
    const nonNullScores = scores.filter(s => s.average != null);
    // The isEmpty() part should not be possible, just being safe
    const numScores = nonNullScores.isEmpty() ? 1 : nonNullScores.size;
    const avg = totalAverages / numScores;
    const summaryObj = skillsOrder.map(skill => ({
      skill: skill,
      val: reduceAllScores(skill, scores),
    }));
    const summaryCells = summaryObj.map((item, i) => (
      <td
        className={classnames(numberClass(item.val), 'skill', hoverIndex === i ? 'hovered' : null)}
        key={`Total-${item.skill}`}
        onMouseEnter={() => this.props.updateHoverIndex(i)}
        onMouseLeave={() => this.props.updateHoverIndex(null)}>
        <TableScore {...{score: item.val}} />
      </td>
    ));
    return (
      <tfoot>
        <tr>
          <td className="rep-name freeze-left">
            <span>Team Average</span>
          </td>
          {summaryCells}
          <td
            className={classnames(
              'score-avg',
              'freeze-right',
              numberClass(avg),
              hoverIndex === -1 ? 'hovered' : null
            )}
            onMouseEnter={() => this.props.updateHoverIndex(-1)}
            onMouseLeave={() => this.props.updateHoverIndex(null)}>
            <TableScore {...{score: avg}} />
          </td>
          <td className="scorecard-count freeze-right">
            <div>{scorecardsCount}</div>
          </td>
        </tr>
      </tfoot>
    );
  }
}

TableFoot.displayName = 'SAW-TableFoot';
export default TableFoot;
